import { render, staticRenderFns } from "./CustomerCreateReturn.vue?vue&type=template&id=50171bf2"
import script from "./CustomerCreateReturn.vue?vue&type=script&lang=js"
export * from "./CustomerCreateReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports